module.exports = __webpack_public_path__ + "img/icon4.dc0e5c9b.png";